module.exports = __webpack_public_path__ + "static/img/girl-02.4bca64d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/girl-02.jpg
// module id = q5xK
// module chunks = 0